// extracted by mini-css-extract-plugin
export default {"superDetailBlock__block":"SuperDetailBlock_superDetailBlock__block__yZV0P"};